module.exports = __webpack_public_path__ + "4db22f6c7842ce9428401c6f996f370f.svg";